import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
import { postOrPutRequest, encryptData } from "../../utils/utils";

const Form2FA = ({ fileName, setView2FA, factor }) => {
    const navigate = useNavigate();
    const InitialForm = {
        otp: "",
        factor_id: factor
    }
    const [formulario, setFormulario] = useState(InitialForm);

    const validateDataForm = (e) => {
        e.preventDefault();

        if(formulario.factor_id === null || formulario.factor_id === undefined || formulario.factor_id === ""){
            Swal.fire({
                title: 'Método de verificación no identificado',
                text: 'No se ha podido identificar el método de verificación. Por favor, intente iniciar sesión nuevamente.',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                timer: 3000
            });
            setView2FA(false);
            navigate('/');
            return;
        }
        if (formulario.otp === "" || formulario.otp.length !== 6 || formulario.otp === null || formulario.otp === undefined) {
            Swal.fire({
                title: 'Código inválido',
                text: 'Por favor ingrese un código de verificación válido',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
            });
            return;
        }
        sendData();
    }

    const sendData = async () => {
        const response = await postOrPutRequest(
            `auth/two-factor`,
            'POST',
            formulario,
            false
        );

        if (response.type === 'success') {
            Swal.fire({
                title: '¡Bienvenido!',
                text: 'Código verificado, acceso concedido',
                icon: 'success',
                confirmButtonText: 'Aceptar',
                timer: 3000
            }).then(() => {
                if (response.token && !response.token_type && !response.access_token && !response.data) {
                    navigate(`/reset/${response.token}`);
                    return;
                }

                Cookies.set(process.env.REACT_APP_TOKEN, encryptData(response.access_token), { expires: 1 });
                Cookies.set(process.env.REACT_APP_USER, encryptData(JSON.stringify(response.data)), { expires: 1 });

                if (response.data.type_id === 4 && response.data.company.completed === 0) {
                    navigate('/InitForm');
                    return;
                }
                navigate('/PanelDeControl');
                return;
            });
        } else {
            console.log(response);
            if(response.errors){
                const listErrors = Object.entries(response.errors)
                .map(([campo, mensaje]) => `<li>• ${mensaje}</li>`)
                .join('');
                Swal.fire({
                    title: `Verifique su información`,
                    html: `<ul style="text-align: left;">${listErrors}</ul>`,
                    icon: 'warning',
                    confirmButtonText: 'Aceptar',
                });
                return;
            }
            Swal.fire({
                title: 'Verifique su información',
                text: response.message,
                icon: 'warning',
                confirmButtonText: 'Aceptar',
                timer: 5000
            });
        }
    }

    return (
        <div className="w-full md:w-1/2 flex flex-col justify-end md:justify-between items-center mb-4 overflow-y-auto">
            <div></div>
            <div className="w-3/4 flex flex-col justify-center items-center mb-4">
                <div className="w-full relative">
                    <form onSubmit={validateDataForm} id="LogIn" className="overscroll-noe overflow-y-auto">
                        <h1 className="block text-sm sm:text-xl font-medium text-stone-700 dark:text-white">Verificación de Inicio de sesión</h1>
                        <p className="mb-4 block font-normal text-xs text-stone-400 dark:text-stone-400">Por favor ingrese el código enviado a su correo electrónico</p>
                        <div className="mb-2">
                            <label className="mb-1 block font-medium text-sm md:text-sm text-slate-700 dark:text-white">
                                Código de verificación
                            </label>
                            <div className="relative">
                                <input
                                    type="text"
                                    name="otp"
                                    placeholder="Ingrese su código de verificación"
                                    className="w-full text-xs md:text-sm rounded-md border dark:border-stone-400 placeholder-stone-400 border-stroke bg-transparent py-3 px-2 sm:pl-6 pr-10 text-black outline-none focus:border-turquesa dark:text-white focus-visible:shadow-none"
                                    onChange={(e) => setFormulario({ ...formulario, otp: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="mb-1 flex flex-wrap">
                            <button
                                className="w-1/2 text-sm md:text-sm font-medium cursor-pointer rounded-md border border-Turquesa dark:border-stone-400 placeholder-stone-400 bg-turquesa py-3 px-2 text-white transition hover:bg-opacity-90 capitalize"
                                type="submit"
                            >
                                Ingresar
                            </button>
                            <button
                                className="w-1/2 text-sm md:text-sm font-medium cursor-pointer rounded-md border border-Turquesa dark:border-stone-400 placeholder-stone-400 bg-zinc-500 py-3 px-2 text-white transition hover:bg-opacity-90 capitalize"
                                type="button"
                                onClick={() => { setView2FA(false); navigate('/'); }}
                            >
                                Cancelar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="flex flex-row w-full px-12 bg-transparent min-h-[100px] overflow-hidden">
                {fileName && <div className="flex flex-row flex-wrap w-full justify-center items-center gap-2">
                    <div className="w-auto px-1 py-3 bg-white rounded-lg">
                        <img
                            src={`${process.env.REACT_APP_PHOTO_URI}photo/ribbon/image/${fileName}`}
                            className="w-full object-contain"
                            alt=""
                        />
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default Form2FA;